import React, { useContext } from 'react';
import { Dialog } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { UserContext } from '../../Context/UserContext';

function PurchaseSuccessModal({ open, handleClose, property, purchaseData }) {
  const { userDetails } = useContext(UserContext);
  if (!property || !purchaseData) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '24px',
          padding: '32px',
          backgroundColor: '#FFFFFF',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }
      }}
    >
      <div className="flex justify-center mb-6">
        <CheckCircleIcon style={{ color: '#00BC67', fontSize: '80px' }} />
      </div>

      <h2 className="text-[20px] font-bold text-back-color2 mb-4">Success!</h2>

      <p className="text-[14px] text-gray-500 mb-8 leading-relaxed">
        You have successfully purchased {purchaseData.units} unit in {property.title}.
        A signed certificate of ownership has been generated and sent to
        {" "}{userDetails?.emailAddress || ''}
      </p>

      <button
        onClick={handleClose}
        className="w-full bg-primary-color text-white font-bold py-3.5 rounded-xl text-[14px] hover:bg-[#00a359] transition-colors"
      >
        Done
      </button>

    </Dialog>
  );
}

export default PurchaseSuccessModal;
